const fmtPrice = (min, max) => {
  if (min == null && max == null) return '';
  if (min != null && max != null) return min === 0 && max === 0 ? 'Ücretsiz' : `${min}–${max} TL`;
  return `${min ?? max} TL`;
};

// AI çıktısından Etkinlik Projesi payload'ı — bilinmeyen alanlar boş kalır
export const ideaToProject = (idea, originalBrief = '') => {
  const notes = [
    originalBrief.trim() && `İlk kullanıcı brief’i (sonraki revizyonlar önceliklidir): ${originalBrief.trim()}`,
    idea.concept && `Konsept: ${idea.concept}`,
    idea.why_it_can_work?.length && `Neden çalışır: ${idea.why_it_can_work.join(' · ')}`,
    idea.main_risks?.length && `Riskler: ${idea.main_risks.join(' · ')}`,
    idea.next_steps?.length && `Sonraki adımlar: ${idea.next_steps.join(' · ')}`,
    fmtPrice(idea.suggested_ticket_price_min, idea.suggested_ticket_price_max) && `Önerilen bilet: ${fmtPrice(idea.suggested_ticket_price_min, idea.suggested_ticket_price_max)}`,
    idea.target_audience && `Hedef kitle: ${idea.target_audience}`,
  ].filter(Boolean).join('\n');
  const pmin = idea.suggested_ticket_price_min, pmax = idea.suggested_ticket_price_max;
  const avg_ticket_price = (pmin != null && pmax != null) ? Math.round((pmin + pmax) / 2) : (pmin ?? pmax ?? 0);
  return {
    title: idea.title,
    description: idea.short_description || '',
    event_type: idea.event_type || null,
    expected_attendees: idea.suggested_capacity || null,
    preferred_districts: idea.suggested_districts || [],
    ...Object.fromEntries(['preferred_neighborhoods', 'excluded_neighborhoods', 'excluded_districts'].map(key => [key, [...(idea[key] || [])]])),
    preferred_days: [...(idea.preferred_days || [])],
    preferred_time_ranges: [...(idea.preferred_time_ranges || [])],
    venue_budget_model: idea.venue_budget_model || null,
    venue_budget_max_try: idea.venue_budget_max_try ?? null,
    excluded_days: [...(idea.excluded_days || [])],
    technical_needs: [...(idea.technical_needs || [])],
    ...Object.fromEntries(['alcohol_needed', 'outside_materials_needed', 'table_setup_needed',
      'needs_two_person_table_setup', 'needs_personal_workspace', 'min_table_size_expectation']
      .filter(key => idea[key] != null).map(key => [key, idea[key]])),
    avg_ticket_price,
    notes,
    stage: 'idea',
    source: 'idea',
  };
};

